import React, { useEffect, useState } from "react";
import { api } from "../../../utlis/user/api.utlis";
import WhCalen from "../../../assets/user/images/whcalendar.svg";
import RepeatImg from "../../../assets/user/images/Repeat.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../layouts/loader/Loader";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import locationImage from "../../../assets/admin/images/Google_Map.svg";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import ApiService from "../../../core/services/ApiService";
import moment from "moment";
import { decode, encode } from "base-64";
import { routes } from "../../../utlis/user/routes.utlis";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { status, weekDays } from "../../../utlis/common.utlis";

const Details = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [ratingModal, setRatingModal] = useState({ status: false });
  const [cancelled, setCancelled] = useState({ status: false, id: null });
  const [deleteJob, setDeleteJob] = useState({ status: false, id: null });
  const [details, setDetails] = useState();
  const localData = useLocation();
  const id = localData.state?.id;

  const initialValuesRating = {
    rating: "",
    review: "",
  };

  const validationSchemaRating = Yup.object().shape({
    rating: Yup.string().required("Rating is required!"),
    review: Yup.string().required("Review message is required!"),
  });

  const getDetails = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log(response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setDetails(response.data.data.requestDetail);
    } else {
      setDetails();
    }
    setLoading(false);
  };

  const cancelService = async () => {
    setLoading(true);
    const form = JSON.stringify({
      status: 3,
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.cancelServiceRequest + `${cancelled.id}`,
      form
    );
    setCancelled({ status: false, id: null });
    if (response.data.status) {
      toast.success(response.data.message);
      getDetails(api.jobDetail + `?service_request_id=${decode(id)}`);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deleteCareJob = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.jobDelete + `${deleteJob.id}`
    );
    setDeleteJob(false);
    if (response.data.status) {
      toast.success(response.data.message);
      navigate(routes.myJobs, {
        state: {
          tab: 0,
        },
      });
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const completeJob = async (id, userId) => {
    setLoading(true);
    let form = JSON.stringify({
      status: 4,
      userid: userId,
    });
    const response = await ApiService.putAPIWithAccessToken(
      api.serviceRequest + `${id}`,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      toast.success(response.data.message);
      setRatingModal({ status: true });
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const submitRating = async (formValue) => {
    setLoading(true);
    let form = JSON.stringify({
      care_provider_id: details?.requestedProviderList[0]?.provider_id,
      object_id: details?.id,
      object_type: "PROVIDER",
      rating: formValue.rating,
      review: formValue.review,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.submitRating,
      form
    );
    if (response.data.status && response.data.statusCode === 200) {
      toast.success(response.data.message);
      navigate(routes.myJobs, {
        state: {
          tab: 4,
        },
      });
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getDetails(api.jobDetail + `?service_request_id=${decode(id)}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="myjobs-details-section">
          <div className="row">
            <div className="col-md-12">
              <div className="care-title-header">
                <h2 className="heading-title">Care Job Detail</h2>
                <div className="search-filter wd40">
                  <div className="row g-2">
                    {details?.request_status == "Pending" ? (
                      <>
                        <div className="col-md-3">
                          <div className="form-group">
                            <button
                              className="btn-re wd100"
                              onClick={(e) => {
                                e.preventDefault();
                                setDeleteJob({
                                  status: true,
                                  id: details?.id,
                                });
                              }}
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <button
                              className="btn-re wd100"
                              onClick={(e) => {
                                e.preventDefault();
                                setCancelled({ status: true, id: details?.id });
                              }}
                            >
                              Mark As Cancelled
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="col-md-9"></div>
                    )}
                    <div className="col-md-3">
                      <div className="form-group">
                        <Link
                          className="btn-bl wd100"
                          to=""
                          onClick={() => navigate(-1)}
                        >
                          Back
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="myjobs-details-section">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="care-card mb-0">
                      <div className="care-card-head">
                        <div className="care-id">
                          Job ID: <span>{details?.job_id ?? "NA"}</span>
                        </div>

                        <div className="care-status">
                          {details?.status == "1" ? (
                            <Link
                              className="btn-gr"
                              onClick={(e) => {
                                e.preventDefault();
                                completeJob(
                                  details?.id,
                                  details?.provider_userid
                                );
                              }}
                            >
                              Mark As Complete
                            </Link>
                          ) : (
                            <div>
                              Status:{" "}
                              <span
                                style={{ cursor: "default" }}
                                type="button"
                                className={
                                  details?.request_status == "Ongoing" ||
                                  details?.request_status == "Completed"
                                    ? "text-success"
                                    : details?.request_status == "Pending"
                                    ? "text-warning"
                                    : "text-danger"
                                }
                              >
                                {details?.request_status ?? "NA"}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="care-card-body">
                        <div className="care-content">
                          <div className="title-text">
                            {details?.first_name ?? "NA"}
                          </div>
                          <div className="d-flex justify-content-between">
                            <div className="d-flex">
                              <div className="date-text">
                                <img src={WhCalen} />{" "}
                                {moment(details?.start_date).format(
                                  "MM-DD-yyyy"
                                )}{" "}
                                {details?.start_time ?? "NA"}
                              </div>
                              <div className="pointtags-list mx-2">
                                <div className="tags-item1">
                                  {details?.category ?? "NA"}
                                </div>
                                <div className="tags-item-sub1">
                                  {details?.subcategory ?? "NA"}
                                </div>
                              </div>
                            </div>
                            <div className="tags-list float-end">
                              <div className="tags-item-sub">
                                {details?.gender == "M" ? "Male" : "Female"}
                              </div>
                              <div className="tags-item-sub mx-2">
                                Age of who needs care: {details?.age ?? "NA"} Years
                              </div>
                            </div>
                          </div>
                          <div className="care-point-list1">
                            <div className="row">
                              <div className="col-md-4">
                                <div className="jobs-details-point-item">
                                  <h4>Email Id: </h4>
                                  <p className="text-lowercase">
                                    {details?.email_id ?? "NA"}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="jobs-details-point-item">
                                  <h4>Contact phone number of who needs care: </h4>
                                  <p className="text-capitalize">
                                    {details?.fax != "" &&
                                    details?.fax != null &&
                                    details?.fax != undefined
                                      ? details?.fax
                                      : "NA"}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="jobs-details-point-item">
                                  <h4>Phone Number: </h4>
                                  <p className="text-capitalize">
                                    {details?.phone ?? "NA"}
                                  </p>
                                </div>
                              </div>
                              <div className="col-md-4 mt-3">
                                <div className="care-point-box">
                                  <div className="care-point-icon">
                                    <img src={RepeatImg} />
                                  </div>
                                  <div className="care-point-text">
                                    <h4>Frequency: </h4>
                                    <p style={{ height: "25px" }}>
                                      {details?.frequency === "O"
                                        ? "One Time"
                                        : details?.frequency === "W"
                                        ? "Repeat Weekly"
                                        : "Repeat Monthly"}
                                    </p>
                                    <div className="care-day-list">
                                      {details?.days !== null &&
                                      details?.days !== "" &&
                                      details?.days !== undefined
                                        ? JSON.parse(details?.days).map(
                                            (element, index) => {
                                              return (
                                                <div
                                                  key={index}
                                                  className="tags-item-sub me-1"
                                                >
                                                  {weekDays(element)}
                                                </div>
                                              );
                                            }
                                          )
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4 mt-3">
                                <div className="care-point-box">
                                  <div className="care-point-text">
                                    <h4>Prefered Contact: </h4>
                                    <p className="text-capitalize">
                                      {details?.prefer_contacted ?? "NA"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4 mt-3">
                                <div className="care-point-box">
                                  <div className="care-point-text">
                                    <h4>Payment Type: </h4>
                                    <p className="text-capitalize">
                                      {details?.payment_type ?? "NA"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <div className="tags-list">
                            <div className="tags-item-sub">
                              {details?.gender == "M" ? "Male" : "Female"}
                            </div>
                            <div className="tags-item-sub mx-2">
                              Age: {details?.age ?? "NA"}
                            </div>
                          </div>
                          <div className="date-text">
                            <img src={WhCalen} />{" "}
                            {moment(details?.start_date).format("MM-DD-yyyy")}{" "}
                            {details?.start_time ?? "NA"}
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="row g-3">
                      {details?.requestedProviderList?.length !== 0
                        ? details?.requestedProviderList?.map((ele, indx) => {
                            return (
                              <div key={indx} className="col-md-4">
                                <div className="care-card mb-0">
                                  <div className="care-card-head">
                                    <div className="care-user-info">
                                      <div className="care-user-image">
                                        {ele?.care_providers_details?.logo !==
                                          null &&
                                        ele?.care_providers_details?.logo !==
                                          "" &&
                                        ele?.care_providers_details?.logo !==
                                          undefined ? (
                                          <img
                                            src={
                                              ele?.care_providers_details?.logo
                                            }
                                            alt=""
                                            className="me-3"
                                          />
                                        ) : ele.image === null ||
                                          ele.image === "" ||
                                          ele.image === undefined ? (
                                          <img
                                            src={NoImage}
                                            alt=""
                                            className="me-3"
                                          />
                                        ) : (
                                          <img
                                            src={ele.image}
                                            alt=""
                                            className="me-3"
                                          />
                                        )}
                                      </div>
                                      <div className="care-user-text">
                                        <div className="care-user-name">
                                          {ele?.care_providers_details
                                            ?.business_name
                                            ? ele?.care_providers_details
                                                ?.business_name
                                            : ele?.fullname}
                                        </div>
                                        <div className="care-user-rating">
                                          <i className="fa fa-star"></i>{" "}
                                          {ele.avarageRating ?? "0"}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="strip-text">
                                      {ele.user_type == 2
                                        ? "Provider"
                                        : "Staff"}
                                    </div>
                                  </div>
                                  <div className="care-card-body">
                                    <div className="care-pointtags-list">
                                      <div className="care-price-text d-flex justify-content-between">
                                        <div className="exp-text mb-1">
                                          {ele?.care_providers_details
                                            ?.experience ?? 0}{" "}
                                          Years Experience
                                        </div>
                                        <div
                                          className="mb-1"
                                          style={{
                                            color: "#000",
                                            fontWeight: "500",
                                          }}
                                        >
                                          Status:{" "}
                                          <span
                                            style={{ cursor: "default" }}
                                            type="button"
                                            className={
                                              ele?.status == "Confirmed" ||
                                              ele?.status == "Completed" ||
                                              ele?.status == "Ongoing"
                                                ? "text-success"
                                                : ele?.status == "Pending"
                                                ? "text-warning"
                                                : "text-danger"
                                            }
                                          >
                                            {ele?.status ?? "NA"}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="pointtags-list">
                                        <div className="tags-item1">
                                          {ele.category ?? "NA"}
                                        </div>
                                        <div className="tags-item-sub1">
                                          {ele.subcategory ?? "NA"}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="care-location-box mt-2">
                                      <div className="care-point-icon">
                                        <img src={locationImage} />
                                      </div>
                                      <div className="care-point-text">
                                        <h4>Location</h4>
                                        <p>
                                          {ele?.care_providers_details
                                            ?.business_address ?? "NA"}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="">
                                      {ele?.chatStatus == "true" ? (
                                        <Link
                                          className="viewmorebtn mx-1"
                                          to=""
                                          onClick={(e) => {
                                            e.preventDefault();
                                            navigate(routes.userMessage, {
                                              state: {
                                                id: encode(ele?.provider_id),
                                              },
                                            });
                                          }}
                                        >
                                          <i className="fa fa-wechat"></i> Chat
                                        </Link>
                                      ) : null}

                                      <Link
                                        className="viewmorebtn mx-1"
                                        to=""
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate(routes.userDetail, {
                                            state: {
                                              id: encode(ele?.provider_id),
                                            },
                                          });
                                        }}
                                      >
                                        <i className="fa fa-eye"></i> View
                                        Profile
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : null}
                      {details?.in_home_assist == null &&
                      details?.is_editable ? (
                        <div className="col-md-4">
                          <div
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(routes.moreProvider, {
                                state: {
                                  lat: details?.latitude,
                                  lng: details?.longitude,
                                  cateId: details?.subcategoryid,
                                  id: encode(details?.id),
                                },
                              });
                            }}
                            className="care-card mb-0 py-5 d-flex justify-content-center align-items-center"
                          >
                            <div class="circle-button">
                              <div class="plus-icon"></div>
                            </div>
                            <div
                              className="mx-3"
                              style={{
                                fontWeight: 600,
                                color: "#000",
                                fontSize: "1rem",
                              }}
                            >
                              Add Provider & Staff
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="jobs-details-info-card mb-0">
                      <div className="jobs-details-point">
                        <div className="jobs-details-point-item">
                          <h4>Best Time To Call: </h4>
                          <p className="text-capitalize">
                            {details?.best_time_to_call ?? "NA"}
                          </p>
                        </div>
                        <div className="jobs-details-point-item">
                          <h4>Your Relationship To Who Needs Care: </h4>
                          <p>{details?.relationship ?? "NA"}</p>
                        </div>
                        <div className="jobsdetails-location-item">
                          <div className="jobsdetails-location-item-icon">
                            <img src={locationImage} />
                          </div>
                          <div className="jobsdetails-location-item-text">
                            <h4>Address of Client or Person That Needs Care:</h4>
                            <p>{details?.address ?? "NA"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="jobs-details-desc-card mb-0">
                      <h3>Description Of Care Needed</h3>
                      <p>{details?.description ?? "NA"}</p>
                    </div>
                  </div>

                  {(details?.userReviews != undefined &&
                    details?.userReviews?.length !== 0) !== 0 ? (
                    <div className="col-md-12">
                      <h4
                        style={{ color: "#276e91", fontWeight: "600" }}
                        className="pb-2"
                      >
                        Rating & Review
                      </h4>
                      <div class="care-comment-list">
                        {details?.userReviews?.length !== 0
                          ? details?.userReviews?.map((ele, indx) => {
                              return (
                                <div key={indx} class="care-comment-item">
                                  <div class="care-comment-profile">
                                    {ele?.image !== null &&
                                    ele?.image !== "" &&
                                    ele?.image !== undefined ? (
                                      <img src={ele?.image} alt="" />
                                    ) : (
                                      <img src={NoImage} alt="" />
                                    )}
                                  </div>
                                  <div class="care-comment-content">
                                    <div class="care-comment-head">
                                      <div class="">
                                        <h2>{ele?.reviewGivenBy ?? "NA"}</h2>
                                        <div class="care-comment-rating">
                                          <i class="fa fa-star"></i>{" "}
                                          {ele?.rating ?? 0}
                                        </div>
                                      </div>
                                      <div class="care-date">
                                        <i class="fa fa-calendar"></i>{" "}
                                        {moment(ele?.created_date).format(
                                          "MM-DD-yyyy hh:mm A"
                                        )}
                                      </div>
                                    </div>
                                    <div class="care-comment-descr">
                                      {ele?.review ?? "NA"}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={deleteJob.status}
        onHide={() => {
          setDeleteJob({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Care Job</h5>
                <p className="text-center">
                  Deleting this care job cannot be undone. Are you sure you want
                  to proceed ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setDeleteJob({ status: false, id: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteCareJob()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={cancelled.status}
        onHide={() => {
          setCancelled({ status: false, id: null });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0 mt-2">
                  Request Service Cancellation
                </h5>
                {details?.engaugedProviderCount == 0 ? (
                  <p className="text-center">
                    This action is irreversible. Are you sure you want to cancel
                    your service request ?
                  </p>
                ) : (
                  <p className="text-center">
                    {details?.engaugedProviderCount} providers are engaged with
                    this service request. Are you sure you want to cancel it ?
                  </p>
                )}
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setCancelled({ status: false, id: null })}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => cancelService()}
                >
                  Yes
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={ratingModal.status}
        onHide={() => {
          setRatingModal({
            status: false,
          });
        }}
        className=""
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Give Feedback</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValuesRating}
                validateOnChange={true}
                validationSchema={validationSchemaRating}
                onSubmit={submitRating}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form className="findcare-form">
                    <div className="form-group mb-4">
                      <h4>Rating</h4>
                      <div class="star-rating">
                        <Field
                          type="radio"
                          id="star5"
                          name="rating"
                          value="5"
                        />
                        <label for="star5">&#9733;</label>
                        <Field
                          type="radio"
                          id="star4"
                          name="rating"
                          value="4"
                        />
                        <label for="star4">&#9733;</label>
                        <Field
                          type="radio"
                          id="star3"
                          name="rating"
                          value="3"
                        />
                        <label for="star3">&#9733;</label>
                        <Field
                          type="radio"
                          id="star2"
                          name="rating"
                          value="2"
                        />
                        <label for="star2">&#9733;</label>
                        <Field
                          type="radio"
                          id="star1"
                          name="rating"
                          value="1"
                        />
                        <label for="star1">&#9733;</label>
                      </div>
                      <ErrorMessage
                        name="rating"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="mb-3">
                      <div className="form-group search-form-group mb-1">
                        <h4>What are the main reasons for your rating?</h4>
                        <Field
                          type="text"
                          as="textarea"
                          className="form-control"
                          name="review"
                          placeholder="Enter Message"
                          style={{ height: "150px" }}
                        />
                        {/* <span className="form-group-icon">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
                              stroke="#292D32"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.9965 11H16.0054"
                              stroke="#292D32"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M11.9955 11H12.0045"
                              stroke="#292D32"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.99451 11H8.00349"
                              stroke="#292D32"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span> */}
                      </div>
                      <ErrorMessage
                        name="review"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setRatingModal({
                            status: false,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Submit
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Details;
